module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAFVBMVEUAAABVrO5VrO5VrO5VrO5VrO5VrO67MPsPAAAABnRSTlMAgM8QAJ+N+GT2AAAA+UlEQVR4XqXWy01DMRAF0FtDRAMRiALQawA8tEABWbj/Eli8XY7EjcisrWPJnzuT/9XlesxdZe7qe+/Xuuhn79uBBCQVIakISUVIKkJSEZKKkFSEpCIkFSGpCElFSCpCUhGSipBUhKQiJBUhqQhJRUgqQlIRkoqQVISkIiQVIakISUVIKkJSWUBQk89d6yVffdHbQ4se227eATiDzEc/gsyS8jBPql2LlBd8UvWpSPnopHy+UECnBOWXkvJzQgGdkpSBIWX0SBliUH/E4erB2iO6h31vG70B9VbWm+IT7bU36t7y+/AABdQGmj4a9SHr+XFtXa4zSr1+AQpqQbR11bYhAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f537.png
// module id = 1130
// module chunks = 0